import { Stack, Typography } from "@mui/material";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  IProductCategory,
  IProductSubCategory,
} from "../../stateManagement/initial-states/product-category.initial-state";
import {
  IProductCategoryState,
  setMainProductCategory,
} from "../../stateManagement/reducers/productCategoryReducer";
import { IRootReducerT } from "../../stateManagement/reduxStore";
import AnimateButton from "../@extended/AnimateButton";

interface IProps {
  setIsOpen: (isOpen: boolean) => void;
  previewedCategory: IProductCategory;
}

const ProductSubCategoryNav = ({ setIsOpen, previewedCategory }: IProps) => {
  const { mainSubCategoryIndex, mainCategory } = useSelector<
    IRootReducerT,
    IProductCategoryState
  >((state) => state.productCategory);

  const dispatch = useDispatch<any>();

  useEffect(() => {
    window.addEventListener("scroll", () => {
      setIsOpen(false);
    });
  }, []);

  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      sx={{
        width: "100% !important",
        backgroundColor: "#FFFFFF",
        overflowX: "auto !important",
        flexWrap: "nowrap",
        borderTop: "1px solid #DEDFE3",
        boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="center"
        spacing={4}
        id="product-sub-category-nav"
        sx={{
          px: "1rem",
          pt: ".5rem",
          pb: "1rem",
          marginLeft: "auto !important",
          marginRight: "auto !important",
          display: { xs: "flex", md: "flex", lg: "flex" },
          backgroundColor: "#FFFFFF",
        }}
      >
        {previewedCategory.subCategories.map(
          (subCategory: IProductSubCategory, index: number) => {
            const isMainSubCategory =
              mainCategory.name === previewedCategory.name &&
              index === mainSubCategoryIndex;

            return (
              <AnimateButton>
                <Typography
                  key={index}
                  variant="body1"
                  sx={{
                    cursor: "pointer",
                    transition: "all .25s 0s ease-out",
                    borderRadius: "1.5rem",
                    p: ".5rem",
                    px: "1rem",
                    fontSize: "1rem",
                    textWrap: "nowrap",
                  }}
                  className={`hover:bg-primary hover:text-white ${
                    isMainSubCategory ? "bg-primary text-white" : ""
                  }`}
                  onClick={() => {
                    dispatch(
                      setMainProductCategory({
                        category: previewedCategory,
                        subCategoryIndex: index,
                      })
                    );
                    setIsOpen(false);
                  }}
                >
                  {subCategory.name}
                </Typography>
              </AnimateButton>
            );
          }
        )}
      </Stack>
    </Stack>
  );
};

export default ProductSubCategoryNav;
